import * as AGChannel from 'ag-channel'

import {
    ILockInvokeRequest,
    ILockInvokeRequestType,
    ILockInvokeResponse
} from "../../common/PA.Concurrency.Services/PALockClient";
import {
    ILockServiceInternal,ILockServiceAdminClient,
    IServerLockAcquireReleaseResponse, IServerLockChannelMessage
} from "../PA.Concurrency.Core/PA.Concurrency.IF.ServerLock";
import {PAWebSocketClient} from "../PA.Core/PAWebSocketClient";

// Data Structure for client side locks

export class PALockAdminClient
    implements ILockServiceAdminClient {

    private _paLockClientInternal: PALockClientInternal = undefined

    constructor() {
        // No local state
        this._paLockClientInternal = new PALockClientInternal()
    }

    breakLock(classId: string, lockId: number | string): Promise<IServerLockAcquireReleaseResponse> {
       return  this._paLockClientInternal.breakServerLock(classId,lockId)
    }

}



class PALockClientInternal implements ILockServiceInternal {

    private wsc: PAWebSocketClient;

    constructor() {
        //--
        this.wsc = new PAWebSocketClient()
    }

    async getLockMessageChannel(classId: string, lockId: number | string): Promise<AGChannel<IServerLockChannelMessage>> {
        const self = this
        // Don't change this convention, used in PALockService.sendClassObjectNodeUpdate
        let aChannelId = `Class_${classId}_Lock_${lockId}`
        let returnValue: AGChannel<IServerLockChannelMessage> = await self.wsc.getChannel(aChannelId)

        return returnValue
    }


    async breakServerLock(classId: string, arrLockId: number | string): Promise<IServerLockAcquireReleaseResponse> {
        const self = this

        let results: IServerLockAcquireReleaseResponse = undefined

        let requestMessage: ILockInvokeRequest = {
            messageType: ILockInvokeRequestType.breakServerLock,
            classId: classId,
            lockId: arrLockId,
        }

        try {
            let response: ILockInvokeResponse = await self.wsc.invoke('LockService', requestMessage, {})
            results = {
                bSuccess: response.bSuccess,
                sFailureReason: response.sErrors[0],
                Lock: undefined
            }
        } catch (err) {
            results = {
                bSuccess: false,
                sFailureReason: `breakServerLockException: ${err}`,
                Lock: undefined
            }
        }
        return results
    }

}
